import { render, staticRenderFns } from "./MathPractice2.vue?vue&type=template&id=0b8ba4a9&scoped=true&"
import script from "./MathPractice2.vue?vue&type=script&lang=js&"
export * from "./MathPractice2.vue?vue&type=script&lang=js&"
import style0 from "./MathPractice2.vue?vue&type=style&index=0&id=0b8ba4a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ba4a9",
  null
  
)

export default component.exports